import { useEffect } from 'react';

export const useFocusTrap = (
  active: boolean,
  containerRef: React.RefObject<HTMLElement | null>
) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!active || !container) {
      return;
    }

    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ];
    const elements = Array.from(
      container.querySelectorAll<HTMLElement>(focusableSelectors.join(','))
    );
    if (elements.length === 0) {
      return;
    }

    const first = elements[0];
    const last = elements[elements.length - 1];
    if (first) {
      first.focus();
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Tab') {
        return;
      }

      const currentIndex = elements.indexOf(document.activeElement as HTMLElement);
      if (e.shiftKey) {
        if (currentIndex === 0 && last) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (currentIndex === elements.length - 1 && first) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [active, containerRef]);
};
